import React, { useEffect } from 'react';
import { useParams, Navigate, useLocation } from 'react-router-dom';

/**
 * <LegacyRedirect to="/admin/shifts/:shiftId" /> — Iter-182.
 *
 * Map old singular URLs (e.g. /admin/shift/:shiftId, sent in pre-Iter-182
 * emails/SMS) to their plural canonical equivalents while preserving
 * params, query string and hash. Logs a one-time console hint so we know
 * how often legacy links still arrive.
 */
const LegacyRedirect = ({ to }) => {
  const params = useParams();
  const location = useLocation();

  useEffect(() => {
    if (typeof console !== 'undefined') {
      console.info('[LegacyRedirect]', location.pathname, '→', to);
    }
  }, [location.pathname, to]);

  let resolved = to;
  Object.entries(params).forEach(([k, v]) => {
    resolved = resolved.replace(`:${k}`, encodeURIComponent(v || ''));
  });
  return <Navigate to={`${resolved}${location.search || ''}${location.hash || ''}`} replace />;
};

export default LegacyRedirect;
